// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__gGbOv","obliqueLineWrap":"membershipbadge_obliqueLineWrap__T-y08","obliqueLine":"membershipbadge_obliqueLine__2-X9Q"};